import { useEffect, useRef } from 'react';
import useAuth from 'CustomHooks/useAuth';
import useRestaurant from 'CustomHooks/useRestaurant';
import server from 'utils/server';

const WARMUP_TTL_MS = 10 * 60 * 1000;

const useSiaTokenWarmup = () => {
  const { uid, loading } = useAuth();
  const { restaurantId, hasSiaV02 } = useRestaurant();
  const lastWarmupRef = useRef<{
    restaurantId: string;
    at: number;
  } | null>(null);

  useEffect(() => {
    if (loading) return;
    if (!uid || !restaurantId || !hasSiaV02) return;

    const now = Date.now();
    const last = lastWarmupRef.current;

    if (last?.restaurantId === restaurantId && now - last.at < WARMUP_TTL_MS) {
      return;
    }

    lastWarmupRef.current = { restaurantId, at: now };

    server
      .get(`/v03/siaConnector/${restaurantId}/token`, {
        headers: { uid },
      })
      .catch(() => {});
  }, [uid, loading, restaurantId, hasSiaV02]);
};

export default useSiaTokenWarmup;
